import { render, staticRenderFns } from "./ReleaseBulkAudioUpload.vue?vue&type=template&id=97e16940&scoped=true&"
import script from "./ReleaseBulkAudioUpload.vue?vue&type=script&lang=js&"
export * from "./ReleaseBulkAudioUpload.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseBulkAudioUpload.vue?vue&type=style&index=0&id=97e16940&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e16940",
  null
  
)

export default component.exports